import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';

const SOCKET_URL = 'https://harmoniq-app.com/ws';//'http://localhost:8082/ws';

let stompClient = null; 
const onConnectCallbacks = [];

export const connectWebSocket = () => {

    //Ensure only one stomClient is activated 
    if (stompClient && stompClient.connected) {
        console.log('STOMP  already active, returning existing promise. ');
        if (stompClient.connected) {
            return Promise.resolve(stompClient);
        }
        //If active but not yet connected, wait for it to connect
        return new Promise((resolve, reject) => {
            const connectListener = () => {
            removeOnConnectCallback(connectListener);
            resolve(stompClient);
            };
            addOnConnectCallback(connectListener);
        });
    }

    return new Promise((resolve, reject) => {
        const socket = new SockJS(SOCKET_URL, null, { withCredentials: true });
        stompClient = new Client({
            webSocketFactory: () => socket, 
            debug: (str) => console.log('[STOMP]', str),
            reconnectDelay: 5000, 
            onConnect: () => {
                console.log('Stomp Connected');
                onConnectCallbacks.forEach(callback => callback(stompClient));
                resolve(stompClient);
            },
            onStompError: (frame) => {
                console.error('STOMP error', frame);
                //For initial connection errors, we can reject the promise
                if(!stompClient.connected) {
                reject(frame);
                }
            },
            onWebSocketClose: () => {
                console.log('WebSocket closed');
                //No explicit action needed here for re-subscription, as onConnect will handle it
            },
            onDisconnect: (frame) => {
                console.log('[STOMP] disconnected', frame);
                //When disconnecting, clear existing subscriptions if they were no meant to be auto-reconnected
                //For this use case, we re subscribe on onConnect, so no global unsubscribe needed
            }
        });
        stompClient.activate();
    });
};

/**
 * Registers a callback function to be called every time the STOMP client connects (initial or reconnect).
 * If the client is already connected, the callback is executed immediately.
 * @param {Function} callback The function to execute on connect, receives the stompClient as an argument.
 */
export const addOnConnectCallback = (callback) => {
    if (typeof callback === 'function') {
        onConnectCallbacks.push(callback);
        // If already connected, immediately call the callback
        if (stompClient && stompClient.connected) {
            callback(stompClient);
        }
    }
};

/**
 * Removes a previously registered onConnect callback.
 * @param {Function} callback The function to remove.
 */
export const removeOnConnectCallback = (callback) => {
    const index = onConnectCallbacks.indexOf(callback);
    if (index > -1) {
        onConnectCallbacks.splice(index, 1);
    }
};

export const disconnectWebSocket = () => {
    if(stompClient) {
        stompClient.deactivate();
        stompClient = null; // Clear the client reference
        onConnectCallbacks.length = 0; // Clear all callbacks
    }
};

export const sendCommand = (destination, payload = {}) => {
    if(stompClient && stompClient.connected){
        stompClient.publish({
            destination: `/app${destination}`,
            body: JSON.stringify(payload),
        });
    } else {
        console.error('WebSocket not connected');
      }
};


export const subscribeToSessionStatus = (onSessionUpdate) => {
    if (!stompClient || !stompClient.connected) {
        console.error('STOMP client not connected.');
        return;
      }

    return stompClient.subscribe('/topic/session/status', (message) => {
        try {
            const response = JSON.parse(message.body);
            console.log("response: " , response);
            onSessionUpdate?.(response);              
            } catch (e) {
            console.error('Error parsing session status message:', e);            
            }
    });    
};


export const subscribeToSDPStatus = (callback) => {
    if (!stompClient || !stompClient.connected) {
        console.error('STOMP client not connected.');
        return;
    }

    return stompClient.subscribe('/topic/session/sdp', (message) => {
        try {
            const response = JSON.parse(message.body);
            console.log("response SDP: " , response);
            callback(response);
        } catch (e) {
            console.error('Error parsing SDP message:', e);
        }
    });
};


export const subscribeToChat = (customSessionId, callback) => {
    if (!stompClient || !stompClient.connected) {
        console.error('STOMP client not connected. Cannot subscribe to chat.');
        return null;
      }
      console.log("Subscribing to chat for session: ", customSessionId);    
    return stompClient.subscribe(`/topic/room/chat/${customSessionId}`, (message) => {
        try {            
            const chat = JSON.parse(message.body);
            console.log("Received chat message: ", chat);
            callback(chat);
        } catch (e) {
            console.error('Error parsing chat message:', e);
            callback({
                success: false,
                message: 'Invalid message format from server.',
                data: null
            });
        }
    });
};
